import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Clarity from '@microsoft/clarity';

// Only initialise in a real browser — react-snap runs in a headless environment
// where window.clarity never becomes a function, causing TypeError on .event()/.upgrade()
if (typeof window !== 'undefined' && !navigator.userAgent.includes('ReactSnap')) {
  Clarity.init('w72giw8brp');
}

const rootElement = document.getElementById('root');

// Check if the root element has children (pre-rendered by react-snap)
const hasChildren = rootElement && rootElement.hasChildNodes();

if (hasChildren) {
  // Hydrate the pre-rendered content
  const root = ReactDOM.hydrateRoot(rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Normal render for development or if pre-rendering didn't happen
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
